<template>
  <GmapMap
    ref="map"
    class="base-map-area"
    :center="center"
    :zoom="10"
    :options="$options.MAP_OPTIONS"
    @click="updateCircleCenter"
  >
    <GmapCircle
      ref="mapCircle"
      :center="center"
      :radius="value.radius"
      :clickable="true"
      :draggable="editable"
      :editable="editable"
      :options="$options.MAP_CIRCLE_OPTIONS"
    />
  </GmapMap>
</template>

<script>
import styles from '@utils/mapStylesDark'
import { gmapApi } from 'vue2-google-maps'

const MAP_OPTIONS = {
  mapTypeControl: false,
  streetViewControl: false,
  styles,
  zoomControl: false,
  fullscreenControl: true,
  gestureHandling: 'cooperative'
}

const MAP_CIRCLE_OPTIONS = {
  strokeColor: '#102130',
  strokeWeight: 2,
  fillColor: '#dff2ff',
  fillOpacity: 0.5
}

export default {
  name: 'BaseMapCircle',
  MAP_OPTIONS,
  MAP_CIRCLE_OPTIONS,
  model: {
    prop: 'value',
    event: 'update:value'
  },
  props: {
    value: { type: Object, default: { coordinates: [0, 0], radius: 10000 } },
    editable: { type: Boolean, default: false }
  },
  computed: {
    google: gmapApi,
    center() {
      return { lat: this.value.coordinates[0], lng: this.value.coordinates[1] }
    },

    localModel: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('update:value', v)
      }
    }
  },

  mounted() {
    this.$refs.mapCircle.$circlePromise.then(() => {
        const circle = this.$refs.mapCircle.$circleObject
        let dragging = false

        this.google.maps.event.addListener(circle, 'mousedown', function() {
          dragging = true
        })

        this.google.maps.event.addListener(circle, 'mouseup', function() {
          dragging = false
        })

        this.google.maps.event.addListener(circle, 'center_changed', () => {
          if (!dragging) {
            const center = circle.getCenter()
            this.updateCoordinates([center.lat(), center.lng()])
          }
        })

        this.google.maps.event.addListener(circle, 'radius_changed', () => {
          this.updateRadius(circle.getRadius())
        })
      })
  },
  methods: {
    updateCircleCenter(event) {
      this.updateCoordinates([event.latLng.lat(), event.latLng.lng()])
    },

    updateRadius(newRadius) {
      if (newRadius !== this.localModel.radius) {
        this.localModel = {
          ...this.localModel,
          radius: newRadius
        }
      }
    },

    updateCoordinates(newCoordinates) {
      const isUpdated = newCoordinates.some((c, i)=> this.localModel.coordinates[i] !== c)
      if (isUpdated) {
        this.localModel = {
          ...this.localModel,
          coordinates: newCoordinates
        }
      }
    }
  }
};
</script>

<style>
.base-map-area {
  width: 100%;
  height: 350px;
}
</style>
